module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-bg login-bg",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6"
  }, [_c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('user_type')
    }
  }, [_c('p', {
    staticClass: "control-label"
  }, [_vm._v("Register As")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio",
    class: {
      'radio-danger': _vm.errors.has('user_type')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.role_id),
      expression: "newUser.role_id"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "user_type",
      "data-vv-as": "user type",
      "id": "user-type-client"
    },
    domProps: {
      "value": _vm.clientRoleId,
      "checked": _vm._q(_vm.newUser.role_id, _vm.clientRoleId)
    },
    on: {
      "__c": function($event) {
        _vm.newUser.role_id = _vm.clientRoleId
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user-type-client"
    }
  }, [_vm._v("\n                      Client\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "radio",
    class: {
      'radio-danger': _vm.errors.has('user_type')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.role_id),
      expression: "newUser.role_id"
    }],
    attrs: {
      "type": "radio",
      "name": "user_type",
      "id": "user-type-carrier"
    },
    domProps: {
      "value": _vm.carrierRoleId,
      "checked": _vm._q(_vm.newUser.role_id, _vm.carrierRoleId)
    },
    on: {
      "__c": function($event) {
        _vm.newUser.role_id = _vm.carrierRoleId
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user-type-carrier"
    }
  }, [_vm._v("\n                      Carrier\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group-email",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group-email",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group-email",
    class: {
      'has-error': _vm.errors.has('password_confirmation')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Repeat Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password_confirmation),
      expression: "newUser.password_confirmation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password_confirmation",
      "data-vv-as": "password confirmation",
      "type": "password",
      "placeholder": "Repeat Password"
    },
    domProps: {
      "value": (_vm.newUser.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.password_confirmation = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.isCarrier) ? _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('terms_agreed')
    }
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary",
    class: {
      'checkbox-danger': _vm.errors.has('terms_agreed')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.terms_agreed),
      expression: "newUser.terms_agreed"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "styled",
    attrs: {
      "name": "terms_agreed",
      "data-vv-as": "terms agreed",
      "id": "terms_agreed",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newUser.terms_agreed) ? _vm._i(_vm.newUser.terms_agreed, null) > -1 : (_vm.newUser.terms_agreed)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.newUser.terms_agreed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.newUser.terms_agreed = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.newUser.terms_agreed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newUser.terms_agreed = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]) : _vm._e(), _vm._v(" "), (_vm.errors.errors && _vm.errors.errors.length) ? _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.errors.errors), function(error) {
    return _c('div', {
      key: error.msg,
      staticClass: "alert alert-danger text-right",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v("\n                  " + _vm._s(error.msg) + "\n                ")])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('ladda-button', {
    attrs: {
      "size": "large",
      "on-click": _vm.registerUser
    }
  }, [_vm._v("Register")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.login'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" Back to Login")])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('h1', [_vm._v("Register")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "terms_agreed"
    }
  }, [_vm._v("\n                    As a Carrier I agree to the "), _c('a', {
    attrs: {
      "href": "static/TERMS AND CONDITIONS FOR INDEPENDENT CARRIERS.pdf",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")]), _vm._v(".\n                  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-e1714d36"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 1083
// module chunks = 0